import { render, staticRenderFns } from "./UserAggrementBig.vue?vue&type=template&id=0fd3e871&"
import script from "./UserAggrementBig.vue?vue&type=script&lang=js&"
export * from "./UserAggrementBig.vue?vue&type=script&lang=js&"
import style0 from "./UserAggrementBig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports